<template>
  <el-row class="container-card">
    <el-col>
      <Tracks />
    </el-col>
  </el-row>
</template>

<script>
import Tracks from '../components/Table'

export default {
  components: {
    Tracks
  }
}
</script>
